// Action Types
export const SET_IS_HYBRID_APP = "SET_IS_HYBRID_APP";
export const ADD_HYBRID_APP_REG_OTP_RESPONSE = "ADD_HYBRID_APP_REG_OTP_RESPONSE";
export const RESET_HYBRID_APP_REG_OTP_RESPONSE = "RESET_HYBRID_APP_REG_OTP_RESPONSE";
export const SET_OTP_FROM_NATIVE = "SET_OTP_FROM_NATIVE";
export const CLEAR_OTP_FROM_NATIVE = "CLEAR_OTP_FROM_NATIVE";
export const SET_HYBRID_APP_CHECKOUT = "SET_HYBRID_APP_CHECKOUT";
export const RESET_HYBRID_APP_CHECKOUT = "RESET_HYBRID_APP_CHECKOUT";
export const RESET_HYBRID_APP = "RESET_HYBRID_APP";

// Actions
export const setIsHybridApp = (message) => ({
    type: SET_IS_HYBRID_APP,
    payload: message
});

export function addHybridAppRegOTPResponse(response) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: ADD_HYBRID_APP_REG_OTP_RESPONSE,
                payload: response
            });
            resolve(true)
        });
    }
};

export const resetHybridAppRegOTPResponse = () => ({
    type: RESET_HYBRID_APP_REG_OTP_RESPONSE
});

export function setOtpFromNative(otp) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: SET_OTP_FROM_NATIVE,
                payload: otp
            });
            resolve(true)
        });
    }
};

export const clearOtpFromNative = () => ({
    type: CLEAR_OTP_FROM_NATIVE
});

export function setHybridAppCheckout(data) {
    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: SET_HYBRID_APP_CHECKOUT,
                payload: data
            });
            resolve(true)
        });
    }
};

export const resetHybridAppCheckout = () => ({
    type: RESET_HYBRID_APP_CHECKOUT,
});

export const resetHybridApp = () => ({
    type: RESET_HYBRID_APP
});